import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

/**
 * Helper to scroll to top immediately on click, before route transition.
 * Use as onClick handler on Link components.
 */
export const scrollToTop = () => {
  window.scrollTo(0, 0);
};
